<template>
    <div class="card">
      <div @click="toDetail(complaint)">
        <div class="card-header">
          <van-row class="info">
            <van-col span="12">
              <span class="info-title">标题：</span>
              
              <span class="info-value">{{ complaint.srvTitle }}</span>
            </van-col>
          </van-row>
          <van-row class="info">
            <van-col span="12">
              <span class="info-title">销售公司：</span>
              
              <span class="info-value">{{complaint.orgName}}</span>
            </van-col>
            <van-col span="12">
              <span class="info-title">服务产品：</span>
              
              <span class="info-value">{{complaint.srvProduct}}</span>
            </van-col>
          </van-row>

          <van-row class="info">
            <van-col span="12">
              <span class="info-title">专家编号：</span>
              <span class="info-value">{{ complaint.expertCode }}</span>
            </van-col>
          </van-row>
  
          <div class="van-hairline--top">
            <van-row class="info">
              <van-col span="18">
                <span class="info-title">日期：</span>
                
                <span class="info-value">{{ $utils.formatDateTime(complaint.applyTime)}}</span>
              </van-col>  
              <van-col span="6">
                <span class="info-value status"> {{ complaint.srvStatus | newstatus }}</span>
              </van-col>
            </van-row>
          </div>
          
        </div>
       
      </div>
      <!-- <div v-if="order.status == '4'" class="card-btn van-hairline--top">
        <van-button class="btn" >物流跟踪</van-button>
      </div> -->
    </div>
  </template>
  <script>
  // import orderApi from "@/request/orderApi";
  export default {
    name: "ComplaintListCard",
    props: {
      complaint: Object,
    },
    data() {
      return {
        // complaint: {},
        shenTypesList: [
          { value: "产品质量投诉", code: "01" },
          { value: "产品计量投诉", code: "02" },
          { value: "运输批次投诉", code: "03" },
          { value: "包装破损投诉", code: "04" },
          { value: "退货申请", code: "05" },
          { value: "其他投诉", code: "06" },
        ],
        //状态
        statusList: [
          { status: "01", statusName: "已保存" },
          { status: "02", statusName: "待处理" },
          { status: "03", statusName: "已答复" },
          { status: "04", statusName: "处理中" },
          { status: "05", statusName: "已处理" },
          { status: "06", statusName: "待审核" },
          { status: "07", statusName: "已撤销" },
          { status: "08", statusName: "审核拒绝" },
          { status: "09", statusName: "已解决" },
          { status: "10", statusName: "已结案" },
        ],
  
   
      };
    },
    computed: {
      complaintType() {
          let complaintType ="";
          switch (this.complaint.goodsType) {
            case "01":
              complaintType = "普通品";
              break;
            case "02":
              complaintType = "危化品";
              break;
              case "03":
              complaintType = "普通危化品";
              break;
          }
          return complaintType;
      }, 
      
      statusName() {
        let statusName ="";
          switch (this.complaint.transportStatus) {
            case "01":
              statusName = "待审核";
              break;
            case "02":
              statusName = "已生效";
              break;
            case "03":
              statusName = "已失效";
              break;
          }
          return statusName;
      }
    },
    filters: {
        newstatus:function(val){
        let obj={
            '01':'已保存',
            '02':'处理中',
            '03':'已解决',
            '04':'已评价'
        }
        return obj[val];
        }
    },
    methods: {
      toDetail(item) {
        console.log("item", item);
        this.$router.push({
          path:'/servicesDetail',
          query:{
            id:item.expertSrvId
          }
        });
       
      },
     
    },
  };
  </script>
  <style lang="stylus" scoped>
  @import '~@/assets/styles/varibles.styl';
  
  .card {
    margin-top: 10px;
    background: #ffffff;
    padding: 12px 24px;
    font-size: 26px;
    border-radius: 20px;
    .card-header {
      // margin-bottom: 20px;
    }
  
    .card-header, .card-total, .card-info {
      padding: 12px 0;
    }
  
    .card-info, .card-total {
      color: #666666;
    }
  
    .info {
      line-height: 61px;
  
      .info-title {
        display: inline-block;
        min-width: 80px;
        text-align: justify;
        text-align-last: justify;
      }
  
      .info-value {
        margin-left: 16px;
      }
  
      .status {
        padding: 8px 12px;
        border: 1px solid black;
        border-radius: 10px;
      }
    }
  
    .color-red {
      color: #E12020;
    }
  
    .large {
      font-size: 36px;
    }
  
    .card-btn {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      height: 120px;
  
      .btn {
        min-width: 200px;
        height: 72px;
        background: $gradientColor;
        color: #ffffff;
        font-size: 32px;
        border-radius: 40px;
      }
    }
  }
  .van-hairline--top{
      border-top: solid 1px #f0f0f0;
  }
  </style>